/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  Divider,
} from "@material-ui/core";

import StructureFields from "components/_refactor/fields/structure";
import HeaderClientes from "components/_refactor/headers/clients";
import PeriodField, {
  getPeriodLabel,
} from "components/_refactor/fields/period-field";
import BignumbersPrateleiraInfinita from "components/Bignumbers/BignumbersPrateleiraInfinita";
import BignumbersRetireNaLoja from "components/Bignumbers/BignumbersRetireNaLoja";
import BignumbersVendaLink from "components/Bignumbers/BignumbersVendaLink";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import DialogDashboardOmni from "components/Dialogs/DialogDashboardOmni";
import componentStyles from "assets/theme/views/admin/dashboard";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import ClearButton from "components/_refactor/button/clear";
import LoadingData from "components/Loading/LoadingData";

import UtilsFncs from "utils/UtilsFncs";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";
import { IsMobile, IsMobile900 } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

const dataHoje = new Date().toISOString().slice(0, 10);

function DashboardOMNILojista() {
  const snackbar = useSnackbar();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();
  const classes = { ...useStyles(), ...useStylesCardDeck() };

  const [searching, setSearching] = useState(false);
  const [filters, setFilters] = useState({});
  const [filtersLoading, setFiltersLoading] = useState([]);
  const [periodo, setPeriodo] = useState(30);
  const [dataInicial, setDataInicial] = useState(dataHoje);
  const [dataFinal, setDataFinal] = useState();

  const [prateleiraInfinita, setPrateleiraInfinita] = useState(null);
  const [openDashPrateleira, setOpenDashPrateleira] = useState(null);
  const [prateleiraCardLabel, setPrateleiraCardLabel] = useState("");

  const [retireNaLoja, setRetireNaLoja] = useState(null);
  const [openDashRetire, setOpenDashRetire] = useState(null);
  const [retireCardLabel, setRetireCardLabel] = useState("");

  const [vendaLink, setVendaLink] = useState(null);
  const [openDashVenda, setOpenDashVenda] = useState(null);
  const [vendaCardLabel, setVendaCardLabel] = useState("");

  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [errorOmniStore, setErrorOmniStore] = useState(false);
  const [hasNoBrand, setHasNoBrand] = useState(false);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const submit = async () => {
    setCancelLoading(false);
    setSearching(true);
    setPrateleiraInfinita(null);
    setRetireNaLoja(null);
    setVendaLink(null);

    await Api.get(
      "dashboard-omni-store",
      "omnireport",
      UtilsFncs.RestParamsComposer(filters) +
        "&dtIni=" +
        dataInicial +
        "&dtFim=" +
        dataFinal,
      true
    )
      .then((data) => {
        const result = data.Result;

        if (result) {
          setPrateleiraInfinita({
            piQtdPedidosAguardandoConfirmacao:
              result.piQtdPedidosAguardandoConfirmacao,
            piQtdPedidosConfirmados: result.piQtdPedidosConfirmados,
            piValorPedidosConfirmados: result.piValorPedidosConfirmados,
            piQtdPecasPedidosConfirmados: result.piQtdPecasPedidosConfirmados,
            piPrecoMedioPedidosConfirmados:
              result.piPrecoMedioPedidosConfirmados,
            piTicketMedioPedidosConfirmados:
              result.piTicketMedioPedidosConfirmados,
            piPecasPorAtendimentoConfirmado:
              result.piPecasPorAtendimentoConfirmado,
            piPedidosAguardandoConfirmacao:
              result.piPedidosAguardandoConfirmacao,
            piPedidosConfirmados: result.piPedidosConfirmados,
          });
          setRetireNaLoja({
            rlQtdPedidos: result.rlQtdPedidos,
            rlQtdVendasIncrementais: result.rlQtdVendasIncrementais,
            rlValorVendasIncrementais: result.rlValorVendasIncrementais,
            rlQtdPecasVendasIncrementais: result.rlQtdPecasVendasIncrementais,
            rlPrecoMedioVendasIncrementais:
              result.rlPrecoMedioVendasIncrementais,
            rlTicketMedioVendasIncrementais:
              result.rlTicketMedioVendasIncrementais,
            rlPecasPorAtendimentoVendasIncrementais:
              result.rlPecasPorAtendimentoVendasIncrementais,
            rlPedidos: result.rlPedidos,
            rlVendasIncrementais: result.rlVendasIncrementais,
          });
          setVendaLink({
            vlLinksPendentes: result.quantidadeLinksPendentes,
            vlValorLinksPendentes: result.totalLinksPendentes,
            vlLinksPagos: result.quantidadeLinksPagos,
            vlValorLinksPagos: result.totalLinksPagos,
            vlTicketMedio: result.tiketMedido,
          });
          setRetireCardLabel(
            `Retire na Loja - Análise Venda Incremental - Pedidos ${getPeriodLabel(
              {
                period: periodo?.value,
                initialDate: dataInicial,
                finalDate: dataFinal,
              }
            )}`
          );
          setPrateleiraCardLabel(
            `Prateleira Infinita - Pedidos ${getPeriodLabel({
              period: periodo?.value,
              initialDate: dataInicial,
              finalDate: dataFinal,
            })}`
          );
          setVendaCardLabel(
            `Venda Link (app) - Pedidos ${getPeriodLabel({
              period: periodo?.value,
              initialDate: dataInicial,
              finalDate: dataFinal,
            })}`
          );
        } else {
          snackbar.showMessage(
            "Não foram localizados resultados para sua busca.",
            {
              severity: "error",
            }
          );
        }
      })
      .catch((error) => {
        setErrorOmniStore(true);
        console.log(error);
        setLocalStorageApiProblem({
          idMenuAccess: "97",
          screen: "Dashboard OMNI Lojista",
          problem: `Erro na chamada do endpoint dashboard-omni-store - ${error}`,
        });
      })
      .finally(() => setSearching(false));
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setSearching(true);
    setPeriodo(30);
    setDataFinal(undefined);
    setDataInicial(dataHoje);
    setSearching(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setPrateleiraInfinita(null);
    setRetireNaLoja(null);
    setVendaLink(null);
    setRetireCardLabel("");
    setPrateleiraCardLabel("");
    setVendaCardLabel("");
  };

  const handleVerifyRequiredInputs = () => {
    if (filters.idMarca) {
      setLocalStorageActions({
        nomeTela: "Dashboard Omni Lojista",
        idMenu: "97",
        acao: "Clicou para Pesquisar",
      });
      return submit();
    } else {
      if (!filters.idMarca) {
        setHasNoBrand(true);
      }
    }
  };

  useEffect(() => {
    if (errorOmniStore && !cancelLoading) {
      snackbar.showMessage(
        "Ocorreu um erro ao buscar dados do Dashboard OMNI Lojista. Verifique os parâmetros informados.",
        {
          severity: "error",
        }
      );
    }
  }, [errorOmniStore, cancelLoading]);

  useEffect(() => {
    if (filters?.idMarca) {
      setHasNoBrand(false);
    }

    if (
      (filters?.idMarca === null &&
        filters?.idCanal === "" &&
        filters?.idRepresentante === "" &&
        filters?.idGrupoEconomico === "" &&
        filters?.idLoja === 0) ||
      periodo === 30
    ) {
      setClearFilters(false);
    }
  }, [filters, periodo]);

  return (
    <>
      <HeaderClientes section="Dashboard OMNI Lojista" subsection="Dashboard" />

      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Grid item xs={12}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title="Filtros"
              titleTypographyProps={{
                component: Box,
                marginBottom: "0!important",
                variant: "h3",
              }}
            ></CardHeader>
            <CardContent>
              <Grid container alignItems="center" spacing={2}>
                <StructureFields
                  clearFilters={clearFilters}
                  onStructureFieldsChange={setFilters}
                  disableAll={searching}
                  onStructureFieldsLoad={setFiltersLoading}
                  requiredFields={["brand"]}
                  hasNoBrand={hasNoBrand}
                />
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={periodo.value === "Outros" ? 12 : 4}>
                  <PeriodField
                    label="Período de Apuração"
                    value={periodo}
                    onChange={setPeriodo}
                    disabled={searching || filtersLoading.length > 0}
                    initialDate={dataInicial}
                    finalDate={dataFinal}
                    setInitialDate={setDataInicial}
                    setFinalDate={setDataFinal}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Button
                    color="default"
                    variant="contained"
                    onClick={handleVerifyRequiredInputs}
                    style={
                      isMobile || isMobile900
                        ? {
                            width: "100%",
                            marginBottom: "0.75rem",
                            marginTop: "0.75rem",
                          }
                        : { marginBottom: "0rem" }
                    }
                    disabled={searching || filtersLoading.length > 0}
                  >
                    {searching ? "Pesquisando..." : "Pesquisar"}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={isMobile ? 12 : isMobile900 && 6}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <ClearButton
                    disable={searching || filtersLoading.length > 0}
                    onClick={() => handleClearFilters()}
                    fullWidth={true}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <LoadingData
            searching={searching}
            onClick={() => handleStopSearching()}
            classes={classes.root}
            label="Buscando dados..."
          />
        </Grid>
        {prateleiraInfinita && !cancelLoading && (
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title={prateleiraCardLabel}
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              />
              <CardContent>
                <BignumbersPrateleiraInfinita
                  data={prateleiraInfinita}
                  onClickLabel={(type) => setOpenDashPrateleira(type)}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
        {retireNaLoja && !cancelLoading && (
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title={retireCardLabel}
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              />
              <CardContent>
                <BignumbersRetireNaLoja
                  data={retireNaLoja}
                  onClickLabel={(type) => setOpenDashRetire(type)}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
        {vendaLink && !cancelLoading && (
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title={vendaCardLabel}
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              />
              <CardContent>
                <BignumbersVendaLink
                  data={vendaLink}
                  onClickLabel={(type) => setOpenDashVenda(type)}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
        {openDashPrateleira && prateleiraInfinita && !cancelLoading && (
          <DialogDashboardOmni
            data={
              openDashPrateleira === "confirmados"
                ? prateleiraInfinita.piPedidosConfirmados
                : prateleiraInfinita.piPedidosAguardandoConfirmacao
            }
            handleClose={() => setOpenDashPrateleira(null)}
            type={openDashPrateleira}
            title={
              openDashPrateleira === "confirmados"
                ? "Quantidade de Pedidos Confirmados"
                : "Quantidade de Pedidos Aguardando Confirmação"
            }
            csvFileName={`${
              openDashPrateleira === "confirmados"
                ? "PedidosConfirmados"
                : "PedidosAguardandoConfirmacao"
            }_PrateleiraInfinita_OMNI_Dashboard.csv`}
          />
        )}
        {openDashRetire && retireNaLoja && !cancelLoading && (
          <DialogDashboardOmni
            data={
              openDashRetire === "pedidos"
                ? retireNaLoja.rlPedidos
                : retireNaLoja.rlVendasIncrementais
            }
            handleClose={() => setOpenDashRetire(null)}
            title={
              openDashRetire === "pedidos"
                ? "Quantidade de Pedidos"
                : "Quantidade de Vendas Incrementais"
            }
            csvFileName={`${
              openDashRetire === "pedidos"
                ? "QuantidadePedidos"
                : "QuantidadeVendasIncrementais"
            }_RetireNaLoja_OMNI_Dashboard.csv`}
          />
        )}
      </Container>
    </>
  );
}

export default DashboardOMNILojista;
